import endpoints from '../constants/endpoints';
import { getAppObj, safe, serialize } from '../utils/utils';
import { getErrorStatus } from '../helpers/formatters';
import { brandIdSelector } from '../helpers/selectors';
import { setAppLoaderState } from './brand';
import { setLoginPending, setLogoutPending } from '../utils/keycloak';
import { logout } from './user';
import { clearAuthTokens, clearSsoTokens, getAppSsoTokens } from '../utils/tokens';
import { STORAGE_KEY } from '../constants/generic';

export function verifyUser(updateIncompleteStatus = true) {
  return (dispatch) => {
    console.log('[KC-DEBUG] actions/keycloak.js/verifyUser: FIRING HTTP GET', { url: endpoints.me, updateIncompleteStatus }); // eslint-disable-line no-console
    console.log('[KC-DEBUG] actions/keycloak.js/verifyUser: ENTER - timestamped; reaching this line at all means kc.init() resolved AUTH (it is the ONLY caller)', { atIso: new Date().toISOString(), perfNowMs: Math.round(performance.now()), url: endpoints.me, hasSsoToken: Boolean(getAppSsoTokens().token), ssoTokenLength: getAppSsoTokens().token?.length, hasSsoRefreshToken: Boolean(getAppSsoTokens().refreshToken), kcAuthenticated: getAppObj().keycloak?.authenticated }); // eslint-disable-line no-console
    return dispatch({
      type: 'keycloak/VERIFY_USER',
      updateIncompleteStatus,
      payload: {
        request: {
          method: 'get',
          url: endpoints.me
        }
      }
    });
  };
}

// noinspection JSUnusedGlobalSymbols
export function handleVerifyUserFail(payload) {
  console.log('[KC-DEBUG] actions/keycloak.js/handleVerifyUserFail: dispatching keycloak/VERIFY_FAILED (the reducer branches on the HTTP status from here)', { httpStatus: getErrorStatus(payload), respType: payload?.type, atIso: new Date().toISOString() }); // eslint-disable-line no-console
  return {
    type: 'keycloak/VERIFY_FAILED',
    payload
  };
}

export function setRegisterExternalUserStatus(payload) {
  console.log('[KC-DEBUG] actions/keycloak.js/setRegisterExternalUserStatus: dispatching keycloak/SET_REGISTER_STATUS', { payload, payloadType: typeof payload }); // eslint-disable-line no-console
  return {
    type: 'keycloak/SET_REGISTER_STATUS',
    payload
  };
}

export function getRemoteKeycloakConfig(email) {
  return (dispatch, getState) => {
    const params = { brandId: brandIdSelector(getState()), email };

    console.log('[KC-DEBUG] actions/keycloak.js/getRemoteKeycloakConfig: FIRING HTTP GET', { url: '/v2/companies/sso-registration', brandId: params.brandId, hasEmail: Boolean(email) }); // eslint-disable-line no-console
    return dispatch({
      type: 'keycloak/GET_REMOTE_CONFIG',
      payload: {
        request: {
          method: 'get',
          url: `/v2/companies/sso-registration?${serialize(params)}`
        }
      }
    });
  };
}

export function handleKeycloakLogin(keycloakConfig) {
  return (dispatch) => {
    const { keycloak } = getAppObj();
    const { createLoginUrl } = keycloak || {};
    const { identityProvider } = keycloakConfig || {};

    console.log('[KC-DEBUG] actions/keycloak.js/handleKeycloakLogin: DECISION `if (createLoginUrl)` (falsy => nothing happens at all, user never leaves for KC)', { hasKcClient: Boolean(keycloak), hasCreateLoginUrl: Boolean(createLoginUrl), identityProvider, hasIdentityProvider: Boolean(identityProvider) }); // eslint-disable-line no-console
    console.log('[KC-DEBUG] actions/keycloak.js/handleKeycloakLogin: ENTER - timestamped; kc client state at the moment the user clicks Login', { atIso: new Date().toISOString(), perfNowMs: Math.round(performance.now()), kcDidInitialize: keycloak?.didInitialize, kcAuthenticated: keycloak?.authenticated, kcRealm: keycloak?.realm, kcAuthServerUrl: keycloak?.authServerUrl, keycloakConfigKeys: keycloakConfig ? Object.keys(keycloakConfig).join(',') : null, keycloakConfigJson: safe(() => JSON.stringify(keycloakConfig)) }); // eslint-disable-line no-console
    if (createLoginUrl) {
      dispatch(setAppLoaderState(true));
      setLoginPending();

      createLoginUrl({
        idpHint: identityProvider,
        prompt: 'login'
      }).then((url) => {
        console.log('[KC-DEBUG] actions/keycloak.js/handleKeycloakLogin: redirecting to KC login URL (query stripped)', { urlWithoutQuery: String(url).split('?')[0], hasIdpHintParam: String(url).includes('kc_idp_hint') }); // eslint-disable-line no-console
        return (window.location.href = url);
      });
    }
  };
}

export function handleKeycloakLogout() {
  return (dispatch) => {
    const { keycloak } = getAppObj();
    const hasKeycloakSession = Boolean(keycloak && keycloak.authenticated);

    console.log('[KC-DEBUG] actions/keycloak.js/handleKeycloakLogout: DECISION - KC logout vs local logout', { hasKeycloakSession, hasLogoutFn: Boolean(keycloak?.logout), usesKcLogout: Boolean(hasKeycloakSession && keycloak.logout) }); // eslint-disable-line no-console
    console.log('[KC-DEBUG] actions/keycloak.js/handleKeycloakLogout: ENTER - timestamped; `authenticated` false here means the app falls back to a LOCAL logout and the KC session survives', { atIso: new Date().toISOString(), perfNowMs: Math.round(performance.now()), kcDidInitialize: keycloak?.didInitialize, kcAuthenticated: keycloak?.authenticated, redirectUri: window.location.origin }); // eslint-disable-line no-console
    if (hasKeycloakSession && keycloak.logout) {
      dispatch(setAppLoaderState(true));
      clearAuthTokens();
      clearSsoTokens();
      sessionStorage.removeItem(STORAGE_KEY.USER);
      setLogoutPending();
      keycloak.logout({ redirectUri: window.location.origin });
    } else {
      dispatch(logout(true));
    }
  };
}
